var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services"},[_c('h1',[_vm._v("Météo à Cappadoce")]),_c('hr'),_c('MeteoActuelle'),_c('PrevisionMeteo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }